<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <slot name="remark"></slot>
        <div v-if="isImg">
          <div class="demo-image">
            <div class="block"
                 v-for="(url,index) of infoFbPicArr"
                 :key="index">
              <el-image style="width: 200px; height: 200px"
                        :src="url"
                        :fit="'scale-down'"
                        :preview-src-list="infoFbPicArr"></el-image>
            </div>
          </div>
        </div>
        <div v-if="isPdf">
          <div v-if="getPDFShow">
            <el-link :href="oldInfoFbFile"
                     target="_blank"
                     type="primary">现场品控工程师信息反馈表</el-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../../components/imageUpload/qeImageUpload"

export default {
  name: 'viewInfoFeedback',
  props: ['oldInfoFbPicArr', 'infoFileType', 'oldInfoFbFile'],
  watch: {
    oldInfoFbPicArr (newValue) {
      this.infoFbPicArr = newValue;
    },
    infoFileType (newValue) {
      if ("IMG" == newValue) {
        // console.log("infoFileType", newValue)
        this.isImg = true
        this.isPdf = false
      } else {
        this.isImg = false
        this.isPdf = true
      }
    }
  },
  data () {
    return {
      infoFbPicArr: this.oldInfoFbPicArr,//原图
      type: "",
      isImg: false,
      isPdf: true,
    }
  },
  components: {
    imageUpload,
  },
  computed: {
    getPDFShow () {
      if (this.oldInfoFbFile && this.oldInfoFbFile.trim() !== '') {
        return true
      }
      return false
    },
  },
  methods: {
    async uploadReprot (fn) {

    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.infoFbPicArr = []
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>

.demo-image {
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;
  align-items: flex-start;
}

.block {
  flex: 0 0 auto;
}




</style>